// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"326":"0e57bbdc","407":"5b485d29","673":"6a47731b"}[chunkId] + ".css";
};